// @flow

import React from "react";

const SECONDS_PER_WEEKS = 604800;

export type Props = $Exact<{
  value: number,
  required: boolean,
  onChange: (value: number) => {},
  options: Object,
}>;

export class SecondsAsWeeksInput extends React.Component<Props> {
  toWeeks = (seconds: number) =>
    isNaN(seconds) ? 0 : Math.round((seconds / SECONDS_PER_WEEKS) * 10) / 10;

  toSeconds = (hours: number) => hours * SECONDS_PER_WEEKS;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    return (
      <div className="schema-form-widget-seconds-as-weeks-input position-relative">
        <input
          type="number"
          className="form-control"
          value={this.toWeeks(this.props.value) || null}
          required={this.props.required}
          disabled={this.props.disabled}
          readOnly={this.props.readonly}
          onChange={this.handleChange}
        />
        <label>weeks</label>
      </div>
    );
  }
}

export default SecondsAsWeeksInput;
